import React, { useEffect, useState } from 'react';
import { Linking } from 'react-native';
import styled from '@emotion/native';
import app from '@appFirebase';

import { Box, Spacer } from '@appComponents/ScreenLayout';
import Text from '@appComponents/Text';
import Button from '@appComponents/Button';
import {
  Content,
  HeaderBorderBottom,
  ContentHeader,
  CardContainer,
  CardContent,
  CardTextDiv,
  CardText,
} from './Settings';

const addPaymentMethodForManager = app
  .functions()
  .httpsCallable('addPaymentMethodForManager');
const getPaymentMethod = app.functions().httpsCallable('getPaymentMethod');
const deletePaymentMethod = app
  .functions()
  .httpsCallable('deletePaymentMethod');

export default ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState({});

  const handleAddPaymentMethodForManager = async type => {
    setLoading(true);
    const data = await addPaymentMethodForManager({ type });
    const linkUrl = data.data.linkUrl;
    Linking.openURL(linkUrl);
    setLoading(false);
  };

  const handleDeletePaymentMethod = async (type, id) => {
    setLoading(true);
    await deletePaymentMethod({ type, id });
    setLoading(false);
  };

  useEffect(() => {
    const load = async () => {
      const data = await getPaymentMethod();
      setPaymentMethods(data.data.paymentMethods);
    };
    load();
  }, [user]);

  return (
    <Content>
      <HeaderBorderBottom>
        <ContentHeader>
          <Text weight={500}>
            PAYMENT PLATFORM FOR SENDING REIMBURSEMENTS TO PILOTS
          </Text>
        </ContentHeader>
      </HeaderBorderBottom>
      <Spacer />
      <Box dir="column" width="100%">
        <Box dir="row" width="100%">
          {user.bankPaymentMethodId ? null : (
            <Button
              disabled={loading}
              loading={loading}
              onPress={() =>
                handleAddPaymentMethodForManager('us_bank_account')
              }>
              Add Bank Account
            </Button>
          )}
          <Spacer size={2} dir="horiz" />
          {user.cardPaymentMethodId ? null : (
            <Button
              disabled={loading}
              loading={loading}
              onPress={() => handleAddPaymentMethodForManager('card')}>
              Add Card
            </Button>
          )}
        </Box>
        {paymentMethods?.bankAccount && (
          <Box dir="row" ai="center" width="100%">
            <CardContainer>
              <CardContent>
                <CardTextTitle>Bank Account</CardTextTitle>
                {paymentMethods.bankAccount?.us_bank_account?.bank_name && (
                  <CardTextDiv>
                    <CardText>Bank Name:</CardText>
                    <CardText>
                      {paymentMethods.bankAccount.us_bank_account.bank_name}
                    </CardText>
                  </CardTextDiv>
                )}
                {paymentMethods.bankAccount?.us_bank_account
                  ?.routing_number && (
                  <CardTextDiv>
                    <CardText>Routing Number:</CardText>
                    <CardText>
                      {
                        paymentMethods.bankAccount.us_bank_account
                          .routing_number
                      }
                    </CardText>
                  </CardTextDiv>
                )}
                {paymentMethods.bankAccount?.us_bank_account?.last4 && (
                  <CardTextDiv>
                    <CardText>Last 4 digits:</CardText>
                    <CardText>
                      {paymentMethods.bankAccount.us_bank_account.last4}
                    </CardText>
                  </CardTextDiv>
                )}
              </CardContent>
            </CardContainer>
            <Spacer size={2} dir="horiz" />
            <Button
              color="error"
              mode="contained"
              disabled={loading}
              loading={loading}
              onPress={() =>
                handleDeletePaymentMethod(
                  'us_bank_account',
                  paymentMethods.bankAccount.id,
                )
              }>
              Remove Bank Account
            </Button>
          </Box>
        )}

        {paymentMethods?.card && (
          <Box dir="row" ai="center" width="100%">
            <CardContainer>
              <CardContent>
                <CardTextTitle>Card</CardTextTitle>
                {paymentMethods.card?.card?.brand && (
                  <CardTextDiv>
                    <CardText>Brand:</CardText>
                    <CardText>
                      {paymentMethods.card.card.brand.toUpperCase()}
                    </CardText>
                  </CardTextDiv>
                )}
                {paymentMethods.card?.billing_details?.name && (
                  <CardTextDiv>
                    <CardText>Name on Card:</CardText>
                    <CardText>
                      {paymentMethods.card.billing_details.name}
                    </CardText>
                  </CardTextDiv>
                )}
                {paymentMethods.card?.card?.last4 && (
                  <CardTextDiv>
                    <CardText>Last 4 digits:</CardText>
                    <CardText>{paymentMethods.card.card.last4}</CardText>
                  </CardTextDiv>
                )}
                {paymentMethods.card?.card?.exp_month && (
                  <CardTextDiv>
                    <CardText>Expiration:</CardText>
                    <CardText>{`${paymentMethods.card.card.exp_month
                      .toString(10)
                      .padStart(2, '0')}/${
                      paymentMethods.card.card.exp_year
                    }`}</CardText>
                  </CardTextDiv>
                )}
              </CardContent>
            </CardContainer>
            <Spacer size={2} dir="horiz" />
            <Button
              color="error"
              mode="contained"
              disabled={loading}
              loading={loading}
              onPress={() =>
                handleDeletePaymentMethod('card', paymentMethods.card.id)
              }>
              Remove Card
            </Button>
          </Box>
        )}
      </Box>
    </Content>
  );
};

const CardTextTitle = styled.Text`
  padding: ${({ theme }) => `${theme.layout.space(0.3)}px`};
  color: ${({ theme }) => theme.colors.text};
  font-size: 20px;
`;
